export const getFilterButtonTitle = (t: Function, filters: string[]) =>
  `${t('common:buttons.filterBy')} ${filters.length > 0 ? `(${filters.length})` : ''}`;
